import { render, staticRenderFns } from "./json-row.vue?vue&type=template&id=422ac760&scoped=true&"
import script from "./json-row.vue?vue&type=script&lang=js&"
export * from "./json-row.vue?vue&type=script&lang=js&"
import style0 from "./json-row.vue?vue&type=style&index=0&id=422ac760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ac760",
  null
  
)

component.options.__file = "json-row.vue"
export default component.exports